export class BaseUser {
  public id: number;
  public name: string;
}



// WEBPACK FOOTER //
// /app/SPA/src/app/models/baseUser.ts